var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscussionIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0526 0C6.32449 0 0 7.12068 0 15.0225C0 17.5463 0.736104 20.1452 2.02804 22.5188C2.2684 22.9094 2.29845 23.4051 2.1332 23.8708L1.12669 27.2359C0.901352 28.0471 1.59239 28.648 2.35854 28.4076L5.39309 27.5063C6.21933 27.2359 6.8653 27.5814 7.63295 28.0471C9.82624 29.339 12.5588 30 15.0225 30C22.4737 30 30.0451 24.2464 30.0451 14.9775C30.0451 6.98548 23.5854 0 15.0526 0",
    fill: "#2884FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9933 16.9607C13.9267 16.9457 13.0704 16.0894 13.0704 15.0228C13.0704 13.9712 13.9417 13.0999 14.9933 13.1149C16.0599 13.1149 16.9162 13.9712 16.9162 15.0378C16.9162 16.0894 16.0599 16.9607 14.9933 16.9607ZM8.06729 16.9606C7.01572 16.9606 6.14441 16.0893 6.14441 15.0377C6.14441 13.9711 7.00069 13.1149 8.06729 13.1149C9.13389 13.1149 9.99018 13.9711 9.99018 15.0377C9.99018 16.0893 9.13389 16.9456 8.06729 16.9606ZM19.9955 15.0378C19.9955 16.0894 20.8518 16.9607 21.9184 16.9607C22.985 16.9607 23.8413 16.0894 23.8413 15.0378C23.8413 13.9712 22.985 13.1149 21.9184 13.1149C20.8518 13.1149 19.9955 13.9712 19.9955 15.0378Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussionIconSelected);
export default __webpack_public_path__ + "static/media/discussion-icon-selected.48409c12a91d2b557e33b4ba458894a2.svg";
export { ForwardRef as ReactComponent };